<template>
  <div class="login-container">
    <div
      class="form-signin"
    >
      <div class="col-12">
        <img src="../../assets/routa_light_S.png" style="display: block; margin-left: auto; margin-right: auto; width: auto; height: 6em; margin-bottom: 1em" alt="logo">
      </div>
      <h2 class="form-signin-heading">
        Routa - {{ $t('users.change_password') }}
      </h2>
        <div class="row my-1">
            <div class="input-group">
                <input
                    v-model="password"
                    :type="showFirstPassword ? 'text' : 'password'"
                    :placeholder="$t('users.new_password')"
                    class="form-control"
                    autocomplete="new-password"
                    @input="validatePassword"
                />
                <button
                    class="btn btn-light btn-sm"
                    style="max-height: 3.3em; border: #BCBCBC 1px solid"
                    @mousedown="showFirstPassword = true"
                    @mouseup="showFirstPassword = false"
                    @mouseout="showFirstPassword = false"
                >
                    <i class="fas fa-eye"></i>
                </button>
            </div>
        </div>
        <div class="row my-1">
            <div class="input-group">
                <input
                    v-model="confirmPassword"
                    :disabled="!passwordOk"
                    :type="showConfPassword ? 'text' : 'password'"
                    :placeholder="$t('users.password_again')"
                    class="form-control"
                    autocomplete="none"
                    @input="validateConfirmPassword"
                />
                <button
                    class="btn btn-light btn-sm"
                    :disabled="!passwordOk"
                    @mousedown="showConfPassword = true"
                    @mouseup="showConfPassword = false"
                    @mouseout="showConfPassword = false"
                >
                    <i class="fas fa-eye"></i>
                </button>
            </div>
        </div>
        <div class="col-12">
            <button
                class="btn btn-primary btn-md w-100 col-sm-12"
                :disabled=" !confirmPasswordOk"
                @click="changePassword"
            >
              {{ $t('users.change_password') }}
            </button>
      </div>
      <div class="col-12">
        <div
          v-if="passwordChanged"
          class="forgot"
          @click.stop="goToLogin"
        >
          {{ $t('login.title') }}
        </div>
      </div>
        <ul v-if="passwordErrors.length > 0" class="mt-4 ps-0">
            <li v-for="error in passwordErrors" :key="error" class="forgot" style="margin-top: 0.25em; cursor: default;">
                <i class="fas fa-exclamation-circle me-2"></i>{{ error }}
            </li>
        </ul>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
      <RoutaAlert ref="alertRef" />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {ref} from "vue";
import {utility} from "@/components/mixins/Utils";
import RoutaAlert from "@/components/utils/RoutaAlert.vue";
export default {
    name: 'ResetPassword',
    components: {RoutaAlert},
    mixins: [restApi, utility],
    data() {
        return {
            token: '',
            password: '',
            locale: this.getLanguage(),
            confirmPassword: '',
            passwordOk: false,
            confirmPasswordOk: false,
            passwordChanged: false,
            loading: false,
            showFirstPassword: false,
            showConfPassword: false,
            errorMessages: [],
            passwordErrors: [],
        }
    },

    setup() {
        const alertRef = ref(null)
        // Method to show the alert
        const showAlert = (message, variant = 'danger') => {
            alertRef.value?.showAlert(message, variant)
        }

        const showSuccess = (message, variant = 'success') => {
            alertRef.value?.showAlert(message, variant)
        }

        return {alertRef, showAlert, showSuccess}
    },

    created() {
        this.$i18n.locale = this.locale
    },

    mounted: function () {
        this.token = this.$route.query.token
        this.showFirstPassword = false
        this.showConfPassword = false
    },

    methods: {
        changePassword: function () {
            if (!this.confirmPasswordOk) {
                return;
            }

            this.loading = true

            this.restUpdate(this.resetPasswordUrl, {
                token: this.token,
                password: this.password
            }, this.success, this.fail)
        },

        success: function () {
            this.loading = false
            this.password = ''
            this.confirmPassword = ''
            this.passwordChanged = true
            this.showSuccess(this.$t('users.password_set_ok'))
        },

        fail: function (response) {
            this.loading = false

            if(response.data.errors && response.data.errors.length > 0) {
                this.errorMessages = response.data.errors

                this.errorMessages.forEach((msg,index) => {
                    this.passwordErrors.push(this.$t(`validation.${msg}`))
                })
            } else {
                this.showAlert(this.$t('login.expired_password_link'))
            }
        },

        validatePassword: function () {
            if (this.errorMessages.length > 0) {
                this.errorMessages = [];
            }

            this.passwordErrors = [];
            this.passwordOk = true;

            if (this.password.length < 12) {
                this.passwordErrors.push(this.$t('validation.password_min_length'));
                this.passwordOk = false;
            }

            if (!/[A-ZÄÖÅ]/.test(this.password)) {
                this.passwordErrors.push(this.$t('validation.password_uppercase'));
                this.passwordOk = false;
            }

            if (!/[a-zäöå]/.test(this.password)) {
                this.passwordErrors.push(this.$t('validation.password_lowercase'));
                this.passwordOk = false;
            }

            if (!/[0-9]/.test(this.password)) {
                this.passwordErrors.push(this.$t('validation.password_number'));
                this.passwordOk = false;
            }

            if (!/[^A-Za-z0-9äöåÄÖÅ]/.test(this.password)) {
                this.passwordErrors.push(this.$t('validation.password_special'));
                this.passwordOk = false;
            }

            this.confirmPasswordOk = (this.password === this.confirmPassword)
        },

        validateConfirmPassword: function () {
            this.confirmPasswordOk = (
                this.confirmPassword.length >= 12 &&
                this.password === this.confirmPassword
            )
        },

        goToLogin: function () {
            this.$router.push('/')
        }
    }
}
</script>
<style>
@import "../../styles/login.css";
</style>
